import React, { useContext, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import axiosInstance from '../../../services/AxiosInstance';
import { userContext } from '../../../contextProvider/Authentication';
import bnr from "./../../../images/register-bg.jpg";
import SimpleReactValidator from 'simple-react-validator';
import { GoogleLogin } from 'react-google-login';

function Register2() {

	const { showAlert, setCommonData, commonData, siteConfig } = useContext(userContext);
	const history = useHistory();

	const ValidatorReg = useRef(new SimpleReactValidator());

	const [email, setEmail] = useState('');
	const [username, setUsername] = useState('');
	let errorsObj = { email: '', password: '', username: '' };
	const [errors, setErrors] = useState(errorsObj);
	const [password, setPassword] = useState('');
	const [isEmployer, setIsEmployer] = useState(!(siteConfig?.can_reg) ? true : false);
	const [, forceUpdate] = useState();
	const [passLength, setPassLength] = useState(false);
	const [newPass, setNewPass] = useState(false);


	function onSignUp(e) {
		e.preventDefault();
		let error = false;
		const errorObj = { ...errorsObj };
		if (email === '') {
			errorObj.email = 'Email is Required';
			error = true;
		}
		if (password === '') {
			errorObj.password = 'Password is Required';
			error = true;
		}
		if (username === '') {
			errorObj.username = 'Username is Required';
			error = true;
		}
		if (!(ValidatorReg.current.allValid())) {
			ValidatorReg.current.showMessages();
			forceUpdate(1);
		} else if (password.length <= 6) {
			setPassLength(true);
		} else {
			setErrors(errorObj);
			if (error) return;
			showAlert(`You will be registered as ${isEmployer ? "Employer" : "Candidate"} . Do you want to Continue?`, handleRegister, true, true)
		}
	}

	const handleRegister = () => {
		setPassLength(false);
		let role = isEmployer ? 2 : 4;
		let postData = {
			"username": username,
			"password": password,
			"email": email,
			"role": role
		}
		setCommonData({ ...commonData, "showPopupAlert": false })
		axiosInstance(
			'/user-create/', {
			method: 'POST',
			data: postData,
			headers: {
				'Authorization': ''
			}
		}
		).then(res => {
			if (res.status === 201) {
				let userData = btoa(JSON.stringify({
					id: res?.data?.id,
					otp: res?.data?.emailOTP,
					role: res?.data?.role,
					username: username,
					password: password
				}))
				history.push(`/verify-otp/${userData}`)
			}
		}).catch(err => {
			swal("", Object.values(err.response?.data).join(", "), { button: "Try Again!", });
		})
	}

	const responseGoogle = (response) => {
		console.log(response);
	}

	return (
		<>
			<div className="page-wraper">
				<div className="browse-job login-style3">
					<div className="bg-img-fix" style={{ backgroundImage: `url(${bnr})`, height: "100vh" }}>
						<div className="row">
							<div className="col-xl-4 col-lg-5 col-md-6 mt-0 col-sm-12 bg-white z-index2 relative p-a0 content-scroll skew-section left-bottom">
								<div className="login-form style-2">
									{/* <div className="logo-header text-left">
										<Link to={"./"}><img src={logo} alt="" /></Link>
									</div> */}
									<div className="clearfix"></div>
									<div className="tab-content nav p-b30 tab">
										<div id="login" className="tab-pane active ">
											<form className=" dez-form " onSubmit={onSignUp}>
												<h3 className="form-title mb-0 mt-5">Personal Information</h3>
												<div className="dez-separator-outer ">
													<div className="dez-separator bg-primary style-liner"></div>
												</div>
												<label className="mb-0">Enter your E-mail Address </label>
												<div className="form-group input-signup mb-3">
													<input
														value={email}
														onChange={(e) => setEmail(e.target.value)}
														className="form-control h-auto"
														placeholder="example@gmail.com"
														autoComplete='off'
													/>
													<span className="text-danger">
														{ValidatorReg.current.message('email', email, 'email')}
													</span>
													<div className="text-danger">{errors.email && <div>{errors.email}</div>}</div>
												</div>
												<label className="mb-0">Enter your Username </label>
												<div className="form-group input-signup mb-3">
													<input
														value={username}
														onChange={(e) => setUsername(e.target.value)}
														className="form-control h-auto"
														placeholder="Enter the username"
														onKeyPress={(e) => e.target.value.length >= 50 && e.preventDefault()}
													/>
													<div className="text-danger">{errors.username && <div>{errors.username}</div>}</div>
												</div>
												<label className="mb-0">Enter your Password. </label>
												<div className="form-group input-signup mb-0 input-group">
													<input
														value={password}
														type={newPass ? "text" : "password"}
														className="change-password form-control h-auto"
														placeholder="Enter the password"
														autoComplete='off'
														onChange={(e) => {
															setPassword(e.target.value);
															password?.length >= 6 && setPassLength(false);
														}}
														onKeyPress={(e) => e.target.value.length >= 30 && e.preventDefault()}
													/>
													<div className="change-password input-group-text" style={{ cursor: "pointer" }} onClick={() => setNewPass(!newPass)}>
														<i className="fa fa-eye" />
													</div>
													<div className="text-danger">{errors.password && <div>{errors.password}</div>}</div>
												</div>
												{passLength && <div className="text-danger fs-12 mb-3">Password must be minimum 6 characters</div>}
												{
													siteConfig?.can_reg &&
													<span className="custom-control custom-checkbox m-b10 mt-3">
														<input type="checkbox" className="custom-control-input" id="check1" name="example1" checked={isEmployer} onChange={() => setIsEmployer(!isEmployer)} />
														<label className="custom-control-label" htmlFor="check1">Are you an Employer?</label>
													</span>
												}
												<div className="form-group text-center">
													<button type="submit" className="site-button dz-xs-flex m-r5">Sign me up</button>
												</div>
												<div className="dz-social clearfix">
													<h5 className="form-title m-t5 pull-left">Sign In With</h5>
													<ul className="dez-social-icon dez-border pull-right dez-social-icon-lg text-white">
														<li><Link to={'#'} className="fa fa-facebook  fb-btn mr-1" ></Link></li>
														<li><Link to={'#'} className="fa fa-twitter  tw-btn mr-1" ></Link></li>
														<li><Link to={'#'} className="fa fa-linkedin link-btn mr-1"></Link></li>
														<GoogleLogin
															clientId="290234197552-uba6teurplarspefn61u7jgrmogevc2e.apps.googleusercontent.com"
															buttonText=""
															onSuccess={responseGoogle}
															onFailure={responseGoogle}
															cookiePolicy={'single_host_origin'}
														/>
													</ul>
												</div>
											</form>
											<div className="text-center bottom">
												<Link to="/login" className="site-button button-md btn-block text-white">Sign In</Link>
											</div>
										</div>
									</div>
									<div className="bottom-footer clearfix m-t10 m-b20 row text-center">
										<div className="col-lg-12 text-center">
											<span> © Copyright by <i className="fa fa-heart m-lr5 text-red heart"></i>
												<a href='https://www.boscosofttech.com/' target='_blank' rel='noopener noreferrer' >BoscoSoft</a> All rights reserved.</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Register2;